
import React, { Component } from 'react';
import { Dropdown } from 'react-bootstrap';
import Media from './Media';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';


class UgcAssetAction extends Component {
    state = {
        comment: ""

    }
    onChangeComment = event => {
        this.setState({ comment: event.target.value })
    }

    render() {
        const { item, onClickToSubmit, isActive, isRequest } = this.props
        const { comment } = this.state;
        return <div className={`card border-0 box-shadow mx-auto`} style={{ maxWidth: 300 }}>
            <div className="card-body p-4">

                {item.status == 2 ? <div className="mb-4 f-center w-100">
                    <span className="text-success f-center">
                        <FontAwesomeIcon type={'regular'} icon={'check'} iconClass={'me-1'} /> Approved
                    </span>
                </div> : item.status == 3 ? <div className="mb-4 f-center w-100">
                    <span className="text-danger f-center">
                        <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={'me-1'} /> Rejected
                    </span>
                </div> : null
                }



                {item.status == 1 ? <div className="mb-4 row">

                    <Dropdown className='w-50 px-2'>
                        <Dropdown.Toggle variant="danger" className={`w-100 arrow_disabled ${isActive ? `` : `disabled`}`}>
                            <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={'fs-6 me-1'} />
                            Reject
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="p-3 rounded-1" style={{ width: 320 }}>
                            <div className="text-end">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="text-gray-800">Comment <span className="text-gray-500 d-none">(Optional)</span></span>
                                    <span className="text-danger">
                                        <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={'fs-6 me-1'} />
                                        Rejected
                                    </span>
                                </div>
                                <textarea className="form-control mb-2 textarea-min-row-4" onChange={this.onChangeComment}>
                                    {comment}
                                </textarea>
                                <button type="button" className={`btn btn-primary ${isRequest ? `spinner disabled` : ``}`} onClick={() => onClickToSubmit(3, item.post_id, this.state.comment)}>Submit</button>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown className='w-50 px-2'>
                        <Dropdown.Toggle variant="success" className={`w-100 arrow_disabled ${isActive ? `` : `disabled`}`}>
                            <FontAwesomeIcon type={'regular'} icon={'check'} iconClass={'fs-6 me-1'} />
                            Approve
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="p-3 rounded-1" style={{ width: 320 }}>
                            <div className="text-end">
                                <div className="f-between mb-2">
                                    <span className="text-gray-800">Comment <span className="text-gray-500 d-none">(Optional)</span></span>
                                    <span className="text-success">
                                        <FontAwesomeIcon type={'regular'} icon={'check'} iconClass={'fs-6 me-1'} />
                                        Approved
                                    </span>
                                </div>
                                <textarea className="form-control mb-2 textarea-min-row-4" onChange={this.onChangeComment}>
                                    {comment}
                                </textarea>
                                <button type="button" className={`btn btn-primary ${isRequest ? `spinner disabled` : ``}`} onClick={() => onClickToSubmit(2, item.post_id, this.state.comment)}>Submit</button>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div> : null}
                <div className="d-flex align-items-center cursor-pointer">
                    <Media
                        mediaType={2}
                        postFile={item.postFile}
                        socialNetworkId={item.networkId}
                        textContent={item.custom_message}
                        rating={4}
                        mediaHeight={466}
                        mediaWidth={878} />
                </div>
            </div>
        </div>

    }
}

export default UgcAssetAction;